module.exports = __webpack_public_path__ + "static/img/xiong.png";